import React from 'react';
// Icons
import loadingImage from '../../assets/logos/levAR_logo.svg';
// Styles
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  assetBlocked: {
    zIndex: 9999,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    background: 'linear-gradient(45deg, #231f20 0%, #424242 50%, #231f20 100%)',
    '& h2': {
      color: '#fff',
      letterSpacing: '.03em',
      fontSize: '2em',
      fontWeight: 300,
      fontFamily: 'Overpass'
    }
  },
  logo: { height: '25vmin' }
});

const BlockedUI = () => {
  const classes = useStyles();

  return (
    <div className={classes.assetBlocked}>
      <div style={{ textAlign: 'center' }}>
        <img src={loadingImage} className={classes.logo} alt="levAR"/>
        <h2>Asset is not available</h2>
      </div>
    </div>
  )
}

export default BlockedUI;
